import { render, staticRenderFns } from "./RoutePlanElementEditView.vue?vue&type=template&id=54ce2e04&scoped=true"
import script from "./RoutePlanElementEditView.vue?vue&type=script&lang=js"
export * from "./RoutePlanElementEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ce2e04",
  null
  
)

export default component.exports